import { useContext } from "react"
import { DragReorderContext } from "@/components/common/DragReorder/DragReorderProvider"

/**
 * Provides access to drag reorder context, to be used with a Framer Motion Reorder.Group/Item.
 */

export default function useDragReordering() {

  const context = useContext(DragReorderContext)

  if (!context) {
    console.warn('Draggable item is used outside of context. This is expected to be the case when drag reordering is not desired.')
    return
  }

  return context
}